import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useDropzone } from 'react-dropzone';

// material-ui components
import { makeStyles } from "@material-ui/core/styles";

// core components
import Button from "components/CustomButtons/Button.js";
import EditTable from "components/Table/EditTable.js";
import Table from "components/Table/Table.js";
import Confirm from 'views/component/Confirm.js';

import Clearfix from "components/Clearfix/Clearfix";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileUpload, faFileDownload } from '@fortawesome/free-solid-svg-icons'

import styles from 'views/component/Styles.js';

const useStyles = makeStyles(styles);

export default function ProductionPlan(props) {
    const { testcase, onTestcaseChange } = props;

    const classes = useStyles();
    // editable table data
    const [testcaseDataEdit, setTestcaseDataEdit] = useState({ ...testcase });
    // editable toggle
    const [editableList, setEditableList] = useState(false);
    // alert
    const [confirmShow, showConfirm] = useState(false);
    const [resetConfirm, showResetConfirm] = useState(false);

    const [showDrop, setShowDrop] = useState(true);

    const [taskList, setTaskList] = useState([]);
    const [facilitySelect, setFacilitySelect] = useState([]);
    const [taskSelect, setTaskSelect] = useState([]);
    const [productSelect, setProductSelect] = useState([]);
    const noFacility = ['트랙', '분류', '워커', 'RGV'];

    useEffect(() => {
        if (testcase.testcaseId) {
            setFacilitySelect(testcase.facilityList.filter(item => !noFacility.includes(item.modelType)).map(item => {
                return { label: item.name, value: item.facilityId };
            }));
            axios.get('data/task/all/' + testcase.testcaseId).then(response => {
                if(response.data.length !== 0) setShowDrop(false);
                setTaskList(response.data);
                setTaskSelect(response.data.map(item => {
                    return { label: item.name, value: item.taskId, productName: item.productName };
                }));
                const productNames = Array.from(new Set(response.data.map(item => item.productName)));
                setProductSelect(productNames.map(item => ({ label: item, value: item })));
            });
        }
    }, [testcase]);

    const clickEditButton = function () {
        setTestcaseDataEdit({ ...JSON.parse(JSON.stringify(testcase)), removedPlanList: [] });
        setEditableList(true);
    };
    const clickAddButton = function () {
        let tempData = { ...testcaseDataEdit };
        tempData.planList.push({ productName: 0, taskId: "", facilityId: "", startTime: 0, quantity: 999999 });
        setTestcaseDataEdit(tempData);
    };
    const handlePlanChange = function (row, col, value) {
        let tempData = { ...testcaseDataEdit };
        tempData.planList[row][col] = value;
        tempData.planList[row].updated = true;
        setTestcaseDataEdit(tempData);
    };
    const handlePlanRemove = function (row) {
        let tempData = { ...testcaseDataEdit };
        let removedPlan = tempData.planList.splice(row, 1);
        tempData.removedPlanList = [...tempData.removedPlanList, removedPlan[0]];
        setTestcaseDataEdit(tempData);
    };
    const clickResetButton = function () {
        let tempData = { ...testcaseDataEdit };
        tempData.removedPlanList = tempData.planList;
        setTestcaseDataEdit(tempData);
    };
    const onConfirm = function (result) {
        if (result) {
            axios.post('data/plan/listedit',
                { ...testcaseDataEdit, planList: testcaseDataEdit.planList.filter(plan => plan.updated) })
                .then(response => {
                    console.log(response.data)
                    onTestcaseChange();
                    setEditableList(false);
                });
        }
        showConfirm(false);
        showResetConfirm(false);
    };

    const taskSelectFilter = function (row, itemList) {
        return itemList.filter(item => row.productName === item.productName);
    }
    const facilitySelectFilter = function (row, itemList) {
        if (taskList.filter(item => item.taskId === row.taskId).length === 0) {
            return [];
        }
        const facilityList = taskList.filter(item => item.taskId === row.taskId)[0].facility;
        return itemList.filter(item => facilityList.includes(item.value));
    }

    const onDrop = function (acceptedFiles) {
        acceptedFiles.forEach(file => {
            const reader = new FileReader();
            reader.onload = () => {
                let temp = [];
                reader.result.match(/[^\r\n]+/g).forEach((line, index) => {
                    if (index !== 0) {
                        let tokens = line.split(',').map(token => token.trim());
                        if (!testcaseDataEdit.planList.find(item => item.productName === tokens[0])) {
                            let temp2 = { ...testcaseDataEdit };
                            temp2.planList.push({ productName: tokens[0], updated: true });
                            setTestcaseDataEdit(temp2);
                        }
                        const task = taskSelect.find(item => item.productName === tokens[0] && item.label === tokens[1]).value;
                        const facility = facilitySelect.find(item => item.label === tokens[2]).value;
                        temp.push({
                            productName: tokens[0], taskId: task, facilityId: facility, startTime: tokens[3],
                            quantity: tokens[4], updated: true
                        });
                    }
                });
                const removed = testcaseDataEdit.planList.filter(item => item.planId);
                setTestcaseDataEdit({ ...testcaseDataEdit, planList: temp, removedPlanList: removed });
                if (temp.length !== 0) {
                    setShowDrop(false);
                    setEditableList(true);
                }
            }
            reader.readAsText(file, 'euc-kr');
        });
    };

    const onDropRejected = useCallback(() => {
        alert('CSV 파일만 입력 가능합니다');
    }, []);

    const cancelUpload = function (e) {
        e.stopPropagation();
        setShowDrop(false);
    };

    const createDownloadUrl = function (fileName) {
        let base = (axios.defaults.baseURL ? axios.defaults.baseURL : "/GiGAtwinFactory") + "/data/download/";
        return base + testcase.testcaseId + fileName;
    }

    const { getRootProps, getInputProps } = useDropzone({ onDrop, onDropRejected, accept: '.csv' });

    return (
        <div className={classes.cellContentModel}>
            {showDrop ?
                <div {...getRootProps({ className: 'dropzone' })} className={classes.dropzone}>
                    <input {...getInputProps()} />
                    <div className={classes.dropzoneText}>
                        <div>파일을 드래그하여 업로드하거나<br /> 직접 입력해주세요</div>
                        <Button color="info" onClick={e => cancelUpload(e)}>직접입력</Button>
                    </div>
                </div>
                : <> {editableList ? <>
                <Confirm show={confirmShow} title="수정 사항 저장" text="수정된 시나리오 목록을 저장합니다."
                    onConfirm={onConfirm} confirmText="저장" type='info' />
                <Button color="danger" className={classes.right} size="sm" onClick={e => { setEditableList(false) }}>취소</Button>
                <Button color="info" className={classes.right} size="sm" onClick={e => { showConfirm(true) }}>저장</Button>
                <Button color="infoOutline" className={classes.right} size="sm" onClick={clickAddButton}>추가</Button>
                <Clearfix />
                <EditTable
                    tableHeaderColor="primary"
                    tableHead={['상품 명', '공정 명', '설비명', '시작 시간', '목표 수량']}
                    tableCols={['productName', 'taskId', 'facilityId', 'startTime', 'quantity']}
                    tableData={testcaseDataEdit.planList}
                    underlineColor="info"
                    onChange={handlePlanChange}
                    onRemove={handlePlanRemove}
                    types={{ 'startTime': 'number', 'quantity': 'number' }}
                    selects={{ facilityId: facilitySelect, taskId: taskSelect, productName: productSelect }}
                    selectsFilter={{ taskId: taskSelectFilter, facilityId: facilitySelectFilter }}
                />
            </> :
                <>
                    <Confirm show={resetConfirm} title="생산 계획 일괄 생성" text="생산 계획을 일괄 생성 합니다."
                    onConfirm={onConfirm} confirmText="확인" type='info' />
                    <a download href={createDownloadUrl("/plan.csv")}>
                        <Button justIcon color="infoOutline" className={classes.right} size="sm">
                            <FontAwesomeIcon icon={faFileDownload} />
                        </Button>
                    </a>
                    <Button justIcon color="infoOutline" className={classes.right} size="sm" onClick={e => { setShowDrop(true); }}>
                        <FontAwesomeIcon icon={faFileUpload} />
                    </Button>
                    <Button color="infoOutline" className={classes.right} size="sm" onClick={clickEditButton}>수정</Button>
                    <Button color="info" className={classes.right} size="sm" onClick={e => { clickResetButton(); showResetConfirm(true); }}>일괄 생성</Button>
                    <Clearfix />
                    <Table tableHeaderColor="primary"
                        tableHead={['상품 명', '공정 명', '설비명', '시작 시간', '목표 수량']}
                        tableCols={['productName', 'taskName', 'facilityName', 'startTime', 'quantity']}
                        tableData={testcase.planList}
                    />
                </>}
            </>}
        </div>
    );
}